import { RatingType, UserRole } from '../../../../../shared/enums';

const data = {
  [RatingType.ONBOARDING]: () => ([
    {
      name: 'introductoryCallWithEditor',
      label: 'rateProjectModal.onboarding.introductoryCallWithEditor',
      description: 'rateProjectModal.onboarding.customer.introductoryCallWithEditorDescription',
      isDisabled: false,
    },
    {
      name: 'writerProposal',
      label: 'rateProjectModal.onboarding.writerProposal',
      description: 'rateProjectModal.onboarding.customer.writerProposalDescription',
      isDisabled: false,
    },
    {
      name: 'introductoryCallWithWriter',
      label: 'rateProjectModal.onboarding.introductoryCallWithWriter',
      description: 'rateProjectModal.onboarding.customer.introductoryCallWithWriterDescription',
      isDisabled: false,
    },
    {
      name: 'overallRating',
      label: 'rateProjectModal.onboarding.overallRating',
      description: 'rateProjectModal.onboarding.customer.overallRatingDescription',
      isDisabled: true,
    },
  ]),

  [RatingType.OUTLINE]: (userRole) => ([
    {
      name: 'storyStructure',
      label: 'rateProjectModal.outline.storyStructure',
      description: `rateProjectModal.outline.${userRole}.storyStructureDescription`,
      visibleFor: [UserRole.EDITOR, UserRole.CUSTOMER],
      isDisabled: false,
    },
    {
      name: 'toneOfVoice',
      label: 'rateProjectModal.outline.toneOfVoice',
      description: `rateProjectModal.outline.${userRole}.toneOfVoiceDescription`,
      visibleFor: [UserRole.EDITOR],
      isDisabled: false,
    },
    {
      name: 'writingQuality',
      label: 'rateProjectModal.outline.writingQuality',
      description: `rateProjectModal.outline.${userRole}.writingQualityDescription`,
      visibleFor: [UserRole.EDITOR, UserRole.CUSTOMER],
      isDisabled: false,
    },
  ].filter((mark) => mark.visibleFor.includes(userRole))),

  [RatingType.DRAFT]: (userRole) => ([
    {
      name: 'accuracy',
      label: 'rateProjectModal.draft.accuracy',
      description: `rateProjectModal.draft.${userRole}.accuracyDescription`,
      isDisabled: false,
    },
    {
      name: 'toneOfVoice',
      label: 'rateProjectModal.draft.toneOfVoice',
      description: `rateProjectModal.draft.${userRole}.toneOfVoiceDescription`,
      isDisabled: false,
    },
    {
      name: 'storyStructure',
      label: 'rateProjectModal.draft.storyStructure',
      description: `rateProjectModal.draft.${userRole}.storyStructureDescription`,
      isDisabled: false,
    },
    {
      name: 'writingQuality',
      label: 'rateProjectModal.draft.writingQuality',
      description: `rateProjectModal.draft.${userRole}.writingQualityDescription`,
      isDisabled: false,
    },
  ]),

  [RatingType.PROOF]: () => ([
    {
      name: 'finalizingDraft',
      label: 'rateProjectModal.proof.finalizingDraft',
      description: 'rateProjectModal.proof.customer.finalizingDraftDescription',
      isDisabled: false,
    },
    {
      name: 'uploadingPhotos',
      label: 'rateProjectModal.proof.uploadingPhotos',
      description: 'rateProjectModal.proof.customer.uploadingPhotosDescription',
      isDisabled: false,
    },
    {
      name: 'finalDesignProofs',
      label: 'rateProjectModal.proof.finalDesignProofs',
      description: 'rateProjectModal.proof.customer.finalDesignProofsDescription',
      isDisabled: false,
    },
    {
      name: 'overallRating',
      label: 'rateProjectModal.proof.overallRating',
      description: 'rateProjectModal.proof.customer.overallRatingDescription',
      isDisabled: true,
    },
  ]),
};

export default (ratingType, userRole) => data[ratingType](userRole);
